export enum InlineNotificationType {
  Error = 'Error',
  Warning = 'Warning',
  Success = 'Success',
}
export enum InlineNotificationKey {
  BgColor = 'BgColor',
  Border = 'Border',
  BorderLeftColor = 'BorderLeftColor',
  Svg = 'Svg',
}
